export interface Promo {
  id: string
  titulo: string
  imagen: string
}

export const promos: Promo[] = [
  {
    id: 'p-1',
    titulo: 'Tu auto también puede trabajar por vos',
    imagen:
      'https://cdn.magicpatterns.com/uploads/9ojag3s4VhBug3FihkPBe3/heylloyd-image-1787675079347.png',
  },
  {
    id: 'p-2',
    titulo: 'Tu usado casi 100% financiado',
    imagen:
      'https://cdn.magicpatterns.com/uploads/aehXxHrwfuqF7NS9NMhz8w/heylloyd-image-1787675172279.png',
  },
  {
    id: 'p-3',
    titulo: 'Vendé tu usado sin renegar: lo vendemos por vos',
    imagen:
      'https://cdn.magicpatterns.com/uploads/dcFH9m99ettfz1A46483Lg/heylloyd-image-1787675242416.png',
  },
  {
    id: 'p-4',
    titulo: '¿Querés un usado confiable?',
    imagen:
      'https://cdn.magicpatterns.com/uploads/negZ5WRX6iBqWoLTmBuLVS/heylloyd-generated-1787007771141.png',
  },
  {
    id: 'p-5',
    titulo: '¿Necesitás un auto para trabajar?',
    imagen:
      'https://cdn.magicpatterns.com/uploads/gFBvfMxzvVb82BsB7egFV2/heylloyd-generated-1787007360345.png',
  },
  {
    id: 'p-6',
    titulo: '¿Buscás auto familiar?',
    imagen:
      'https://cdn.magicpatterns.com/uploads/c41fZVQqetAcF7Pw5FQC9y/heylloyd-generated-1787007001947.png',
  },
  {
    id: 'p-7',
    titulo: '¿Querés financiar tu auto?',
    imagen:
      'https://cdn.magicpatterns.com/uploads/9RSKf5R3v85M3gST7fVR22/heylloyd-generated-1787006568885.png',
  },
  {
    id: 'p-8',
    titulo: '¿Cómo cambiar tu auto?',
    imagen:
      'https://cdn.magicpatterns.com/uploads/hFGAqy1wpkngmD2uf3Aoy7/heylloyd-image-1787006092171.png',
  },
]
